import React from 'react';
import '../styles/fonts.css';
import ContactForm from './ContactForm';

const gradientTextStyle = {
    background: 'linear-gradient(to right, #ff0000 5%, #ff8c00 10%, #ffd700 65%, #ff69b4 85%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
};

function Solutions() {
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = {
            name: formData.get('name'),
            phone: formData.get('phone'),
            email: formData.get('email'),
            message: formData.get('message')
        };

        // Log the form data (replace with your actual submission logic)
        console.log('Form submitted:', data);

        // Clear the form
        e.target.reset();

        // You can add your API call here
        // Example:
        // fetch('/api/contact', {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(data),
        // });
    };

    return (
        <div className="overflow-hidden" style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
        }}>
            <div className="gradient-circle gradient-circle-left"></div>
            <div className="gradient-circle gradient-circle-right"></div>
            
            {/* Banner section - outside max-width container */}
            <div className="w-100 position-relative">
                <img
                    src="/homeBanner.png"
                    alt="Home Banner"
                    className="img-fluid w-100"
                    style={{
                        height: 'clamp(300px, 50vh, 300px)',
                        objectFit: 'cover'
                    }}
                />
                <div className="position-absolute top-50 start-0 w-100 translate-middle-y">
                    <div className="mx-auto" style={{ maxWidth: '1270px' }}>  {/* Banner content constrained */}
                        <div className="container-fluid px-4 px-md-5">
                            <div className="row justify-content-center">
                                <div className="col-12 col-lg-10">
                                    <div className="text-white">
                                        <img
                                            src="/textLogo.png"
                                            alt="Home Banner"
                                            className="img-fluid"
                                            style={{
                                                maxWidth: '300px',
                                                width: '80%',
                                                objectFit: 'contain',
                                                display: 'block'
                                            }}
                                        />
                                        <div className="text-start">
                                            <h1 className="display-5 my-2" style={{
                                                fontFamily: 'Avenir, sans-serif',
                                                fontSize: 'clamp(10px, 3.5vw, 24px)'
                                            }}>
                                                Services
                                            </h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Rest of content wrapped in max-width container */}
            <div className="mx-auto" style={{ maxWidth: '1728px' }}>
                {/* Services Section */}
                <div className="container-fluid px-4 px-md-5 py-5">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10">
                            <h1 className="display-4 text-start mb-0"
                                style={{
                                    ...gradientTextStyle,
                                    fontFamily: 'Godber, sans-serif',
                                    fontSize: '40px'
                                }}>
                                Cybersecurity Solutions
                            </h1>
                            <div className="row d-flex align-items-center justify-content-between mb-4">
                                <div className="col-auto">
                                    <h2 className="mb-2 text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '36px', fontWeight: 'bold' }}>
                                        Protecting Your Business in a Digital-First World
                                    </h2>
                                </div>
                            </div>
                            <div className="row d-flex align-items-top justify-content-evenly mb-4">
                                <div className="col-1 pe-0">
                                    <div style={{
                                        width: '50px',
                                        height: '5px',
                                        backgroundColor: '#BC2025',
                                        marginBottom: '5px',
                                        marginTop: '5px'
                                    }}></div>
                                </div>
                                <div className="col-11 text-start ps-0">
                                    <span style={{ 
                                        fontFamily: 'Avenir, sans-serif', 
                                        fontSize: 'clamp(16px, 2vw, 24px)' 
                                    }}>
                                        We offer comprehensive cybersecurity solutions designed to safeguard your business from evolving threats. Our expertise in Information Security Assurance ensures your data, systems, and operations remain secure, compliant, and resilient against cyber risks.
                                    </span>
                                </div>
                            </div>

                            <div className="row row-cols-1 g-0">
                                <div className="col">
                                    <div className="card rounded-0 border border-0" style={{ backgroundColor: 'transparent' }}>
                                        <div className="card-body text-start">
                                            <div className='row'>
                                                <h5 className="card-title mb-0" style={{
                                                    color: '#BC2025',
                                                    fontFamily: 'Godber, sans-serif',
                                                    fontSize: '28px'
                                                }}>Information Security Assurance</h5>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <img src="/solutions/1.png" alt="Server Hardware" className="img-fluid" style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        borderRadius: '10px',
                                                        aspectRatio: '1/0.7',
                                                        objectFit: 'cover'
                                                    }} />
                                                </div>
                                                <div className="col-md-8 mt-md-0 mt-3">
                                                    {[
                                                        {
                                                            title: "Assurance Services",
                                                            description: "Risk-based assessments to validate security measures."
                                                        },
                                                        {
                                                            title: "Information Risk Assessment",
                                                            description: "Identifying vulnerabilities and mitigating threats."
                                                        },
                                                        {
                                                            title: "Information Security Management",
                                                            description: "Implementing security governance frameworks."
                                                        },
                                                        {
                                                            title: "Business Continuity & Disaster Recovery (BCP & CDRP)",
                                                            description: "Ensuring resilience against cyber threats and operational disruptions."
                                                        }
                                                    ].map((item, index) => (
                                                        <div className="row " key={index}>
                                                            <div className="row">
                                                                <div className='col'>
                                                                    <span style={{ 
                                                                        fontSize: 'clamp(18px, 2vw, 24px)', 
                                                                        fontFamily: 'Avenir, sans-serif', 
                                                                        fontWeight: 'bold',
                                                                        color: '#BC2025'
                                                                    }}>{item.title}</span>
                                                                    <i className="bi bi-arrow-down-short" style={{ 
                                                                        fontSize: 'clamp(18px, 2vw, 24px)', 
                                                                        fontWeight: 'bold' 
                                                                    }}></i>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <p style={{ 
                                                                    fontSize: 'clamp(14px, 1.5vw, 16px)', 
                                                                    fontFamily: 'Avenir, sans-serif' 
                                                                }}>{item.description}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col">
                                    <div className="card rounded-0 border border-0" style={{ backgroundColor: 'transparent' }}>
                                        <div className="card-body text-start">
                                            <div className='row'>
                                                <h5 className="card-title mb-0" style={{
                                                    color: '#BC2025',
                                                    fontFamily: 'Godber, sans-serif',
                                                    fontSize: '28px'
                                                }}>Solution Integration & Customization</h5>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <img src="/solutions/2.png" alt="System Integration" className="img-fluid" style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        borderRadius: '10px',
                                                        aspectRatio: '1/0.7',
                                                        objectFit: 'cover'
                                                    }} />
                                                </div>
                                                <div className="col-md-8 mt-md-0 mt-3">
                                                    {[
                                                        {
                                                            title: "Infrastructure Security",
                                                            description: "Protecting networks, firewalls, and data centers."
                                                        },
                                                        {
                                                            title: "Mobile Security",
                                                            description: "Securing mobile devices, applications, and remote work environments."
                                                        },
                                                        {
                                                            title: "Backup & Recovery Systems",
                                                            description: "Implementing reliable data protection and disaster recovery solutions."
                                                        },
                                                        {
                                                            title: "Secure IT Infrastructure",
                                                            description: "Strengthening end-to-end security across enterprise systems."
                                                        }
                                                    ].map((item, index) => (
                                                        <div className="row" key={index}>
                                                            <div className="row">
                                                                <div className='col'>
                                                                    <span style={{ 
                                                                        fontSize: 'clamp(18px, 2vw, 24px)', 
                                                                        fontFamily: 'Avenir, sans-serif', 
                                                                        fontWeight: 'bold',
                                                                        color: '#BC2025'
                                                                    }}>{item.title}</span>
                                                                    <i className="bi bi-arrow-down-short" style={{ 
                                                                        fontSize: 'clamp(18px, 2vw, 24px)', 
                                                                        fontWeight: 'bold' 
                                                                    }}></i>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <p style={{ 
                                                                    fontSize: 'clamp(14px, 1.5vw, 16px)', 
                                                                    fontFamily: 'Avenir, sans-serif' 
                                                                }}>{item.description}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col">
                                    <div className="card rounded-0 border border-0" style={{ backgroundColor: 'transparent' }}>
                                        <div className="card-body text-start">
                                            <div className='row'>
                                                <h5 className="card-title mb-0" style={{
                                                    color: '#BC2025',
                                                    fontFamily: 'Godber, sans-serif',
                                                    fontSize: '28px'
                                                }}>Additional Security Services</h5>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <img src="/solutions/3.png" alt="Custom Applications" className="img-fluid" style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                        borderRadius: '10px',
                                                        aspectRatio: '1/0.7',
                                                        objectFit: 'cover'
                                                    }} />
                                                </div>
                                                <div className="col-md-8 mt-md-0 mt-3">
                                                    {[
                                                        {
                                                            title: "Security Code Review",
                                                            description: "Identifying vulnerabilities in software applications."
                                                        },
                                                        {
                                                            title: "Enterprise Architecture Services",
                                                            description: "Aligning IT infrastructure with security best practices."
                                                        },
                                                        {
                                                            title: "Fair-Market Value Analysis",
                                                            description: "Assessing IT security investments for optimal returns."
                                                        },
                                                    ].map((item, index) => (
                                                        <div className="row" key={index}>
                                                            <div className="row">
                                                                <div className='col'>
                                                                    <span style={{ 
                                                                        fontSize: 'clamp(18px, 2vw, 24px)', 
                                                                        fontFamily: 'Avenir, sans-serif', 
                                                                        fontWeight: 'bold',
                                                                        color: '#BC2025'
                                                                    }}>{item.title}</span>
                                                                    <i className="bi bi-arrow-down-short" style={{ 
                                                                        fontSize: 'clamp(18px, 2vw, 24px)', 
                                                                        fontWeight: 'bold' 
                                                                    }}></i>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-2">
                                                                <p style={{ 
                                                                    fontSize: 'clamp(14px, 1.5vw, 16px)', 
                                                                    fontFamily: 'Avenir, sans-serif' 
                                                                }}>{item.description}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Us Section */}
                <ContactForm />
            </div>
        </div>
    );
}

export default Solutions; 